export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/search.worker.5319cadd.worker.js");
}
